import Icon from 'components/atomic/Icon'
import sortBy from 'lodash/sortBy'
import { useState } from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'
import { clearCollapsed, getMenuName, getPlaceholderName } from 'utils'
import { sendGTMData } from '../../utils/gtm'

const RefinementList = ({
  items,
  refine,
  placeholder,
  index,
  noAlgolia = false,
  disabled = false,
  collapsed = false,
  ricerca = false,
  checkCount = false,
}) => {
  const hasValoriDisponibili = checkCount ? items.some(item => Boolean(item.count)) : true

  if (!hasValoriDisponibili) return null

  const [chiuso, setChiuso] = useState(collapsed && Boolean(index))

  const isEta = ['Eta', "Fascia d'età"].includes(placeholder)
  let orderedItems = items

  if (isEta)
    orderedItems = sortBy(
      orderedItems.map(item => ({ ...item, label: Number(item.label) })),
      ['label']
    )
  else if (ricerca) orderedItems = sortBy(orderedItems, ['label'])

  const handleGTM = (item, placeholder, checked) => {
    if (checked) {
      sendGTMData({
        event: 'GAevent',
        eventID: '12',
        eventCategory: 'filtri_risorse',
        eventAction: placeholder.toGTMFormat(),
        eventLabel:
          typeof item.label === 'string'
            ? item.label.toGTMFormat()
            : item.label.toString().toGTMFormat(),
      })
    }
  }

  return (
    <div
      className={`box ${chiuso ? 'box--collapsed' : ''} ${
        !orderedItems.length || disabled ? 'box--disabled' : ''
      }`}
    >
      <p
        className="box__placeholder"
        onClick={() => {
          if (orderedItems.length) {
            clearCollapsed()
            setChiuso(!chiuso)
          }
        }}
      >
        {getPlaceholderName(placeholder)}
      </p>
      <div className="box__choices">
        {orderedItems.map((item, index) => (
          <label
            className={`box__choice ${
              !item.count && !noAlgolia ? 'box__choice--disabled' : ''
            } w-form__checkbox-wrapper`}
            htmlFor={item.label}
            key={index}
          >
            <input
              type="checkbox"
              id={item.label}
              name={item.label}
              checked={item.isRefined}
              onChange={e => {
                refine(item.value || item.id)
                handleGTM(item, getPlaceholderName(placeholder), e.target.checked)
              }}
              disabled={(!item.count && !noAlgolia) || disabled}
            />
            <span
              className={`box__choice__flag ${
                item.isRefined || item.selezionato || item.selected
                  ? 'box__choice__flag--checked'
                  : ''
              }`}
            >
              {/* w-form__styled-input */}
              <Icon id="check--review" />
            </span>
            <span>
              {isEta ? item.label : getMenuName(item.label.capitalize())}
              {/* ({item.count}) */}
            </span>
          </label>
        ))}
      </div>
    </div>
  )
}

export { RefinementList as BaseRefinementList }

export default connectRefinementList(RefinementList)
